import { getWebDomain } from './getApiDomain';

/**
 *
 * @param url 跳转的url
 * @param outUrl 是否是外站点的url
 */
export const openNewTab = (url: string, outUrl?: boolean) => {
  let openUlr = url;
  if (!outUrl) {
    const domain = getWebDomain();
    openUlr = domain + url;
  }
  window.open(openUlr, '_blank');
};
